import styles from "./synced-widget-header.module.css";

interface SyncedWidgetHeaderProps {
  title: string;
  subtitle: string;
}

export default function SyncedWidgetHeader({ title, subtitle }: SyncedWidgetHeaderProps) {
  return (
    <div className={styles.container}>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.subtitle}>{subtitle}</p>
    </div>
  );
}
